var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70633 4.41009C5.53344 4.24311 5.30189 4.15072 5.06154 4.15281C4.82119 4.15489 4.59128 4.2513 4.42133 4.42126C4.25137 4.59121 4.15496 4.82113 4.15287 5.06147C4.15079 5.30182 4.24318 5.53337 4.41016 5.70626L9.70391 11L4.40924 16.2938C4.32169 16.3783 4.25186 16.4795 4.20382 16.5913C4.15577 16.7031 4.13049 16.8234 4.12943 16.9451C4.12837 17.0669 4.15156 17.1876 4.19766 17.3002C4.24375 17.4129 4.31181 17.5152 4.39788 17.6013C4.48395 17.6874 4.5863 17.7554 4.69895 17.8015C4.81161 17.8476 4.93231 17.8708 5.05403 17.8697C5.17574 17.8687 5.29603 17.8434 5.40786 17.7954C5.5197 17.7473 5.62085 17.6775 5.70541 17.5899L11.0001 12.2962L16.2938 17.5899C16.4667 17.7569 16.6983 17.8493 16.9386 17.8472C17.179 17.8451 17.4089 17.7487 17.5788 17.5788C17.7488 17.4088 17.8452 17.1789 17.8473 16.9385C17.8494 16.6982 17.757 16.4666 17.59 16.2938L12.2962 11L17.59 5.70626C17.757 5.53337 17.8494 5.30182 17.8473 5.06147C17.8452 4.82113 17.7488 4.59121 17.5788 4.42126C17.4089 4.2513 17.179 4.15489 16.9386 4.15281C16.6983 4.15072 16.4667 4.24311 16.2938 4.41009L11.0001 9.70384L5.70633 4.40917V4.41009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhite);
export default __webpack_public_path__ + "static/media/ic-close-white.d1a0a9feeef370c9ee8f6472c2f40a96.svg";
export { ForwardRef as ReactComponent };